import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Donations from '@/components/Donation-options'
import Amount from '@/components/Amount'
import ConfirmScreen from '@/components/confirm-screen'
import Login from '@/components/login'
import getTerminalId from '@/components/getTerminalId'

import Reports from '@/components/Reports/reports'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import DonationRequested from '@/components/donation-requested'
import ThanksGiving from '@/components/thanks-giving'
import Reciept from '@/components/reciept'
import PaymentFailed from '@/components/payment-failed'
import TimeOut from '@/components/timeout'
import EODReports from '@/components/Reports/eodReports'
import ChangeAmount from '@/components/amount-change'

require('swiper/dist/css/swiper.css')

Vue.use(Router)
Vue.use(VueAwesomeSwiper)

export default new Router({
  routes: [
    {
      path: '/:terminalId/',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'getTerminalId',
      component: getTerminalId
    },
    {
      path: '/:terminalId/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/:terminalId/donations',
      name: 'Donations',
      component: Donations
    },
    {
      path: '/:terminalId/amount-select/:donationType',
      name: 'Amount',
      component: Amount,
      props: true
    },
    {
      path: '/:terminalId/change-amount/:donationType/:donationAmount',
      name: 'change-amount',
      component: ChangeAmount,
      props: true
    },
    {
      path: '/:terminalId/confirm/:donationType/:donationAmount',
      name: 'ConfirmScreen',
      component: ConfirmScreen,
      props: true
    },
    {
      path: '/:terminalId/payment-confirm/:donationType/:donateAmount',
      name: 'PaymentConfirm',
      component: DonationRequested,
      props: true
    },
    {
      path: '/:terminalId/thanks-giving/:donationType/:donateAmount/:paymentId',
      name: 'ThanksGiving',
      component: ThanksGiving,
      props: true
    },
    {
      path: '/:terminalId/receipt/:donationType/:donateAmount/:paymentId',
      name: 'Reciept',
      component: Reciept,
      props: true
    },
    {
      // http://localhost:8081/#/22162165/payment-failed/CANCELLED/Zakah/5/293
      path: '/:terminalId/payment-failed/:failedReason/:donationType/:donateAmount/:paymentId',
      name: 'PaymentFailed',
      component: PaymentFailed,
      props: true
    },
    {
      path: '/:terminalId/time-out/:failedReason/:donationType/:donateAmount/:paymentId',
      name: 'TimeOut',
      component: TimeOut,
      props: true
    },
    {
      path: '/:terminalId/reports',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/:terminalId/eodReports',
      name: 'EODReports',
      component: EODReports
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js